import React, { useState, useEffect } from "react";

const TimerFromTimestamp = ({ timestamp }) => {
  const [time, setTime] = useState(0);

  useEffect(() => {
    // Calculate the difference from the timestamp to now, initially
    const nowUnix = Math.floor(new Date().getTime() / 1000);
    const startTime = nowUnix - timestamp;
    console.log("elapsed: ", startTime);

    // Function to update the time every second
    const interval = setInterval(() => {
      const nowUnix = Math.floor(new Date().getTime() / 1000);
      const elapsed = nowUnix - timestamp;
      console.log("elapsed: ", elapsed);
      setTime(Math.floor(elapsed));
    }, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [timestamp]);

  // Calculate minutes and seconds from the time (elapsed seconds)
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  // Pad with leading zero for single-digit seconds

  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return (
    <div>
      {formattedMinutes}:{formattedSeconds}
    </div>
  );
};

export default TimerFromTimestamp;
